export const TYREHUB = 'HT TYREHUB SDN BHD'
export const PERFORMANCE = 'HT PERFORMANCE TYRE SDN BHD'
export const TRUCK = 'HT TRUCK SERVICE SDN BHD'
export const LUBRICANT = 'HT LUBRICANT SDN BHD'
export const ECO = 'HT ECO BATTERY SDN BHD'
export const BRAKES = 'HT BRAKES SDN BHD'
export const EKOTAYAR = 'HT EKOTAYAR SDN BHD'

export const SALES_COMMISSION_COMPANIES = {
  TYREHUB: TYREHUB,
  LUBRICANT: LUBRICANT,
  ECO: ECO,
  EKOTAYAR: EKOTAYAR,
  BRAKES: BRAKES,
  PERFORMANCE: PERFORMANCE,
}
